import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

export interface ClientInfo {
  nom: string;
  prenom: string;
  email: string;
  telephone: string;
  adresse: string;
  dateNaissance?: string;
}

export interface OccupantDetails {
  nombreAdultes: number;
  nombreEnfants: number;
  avecAnimalCompagnie: boolean;
  ageEnfantSuperieurASept: boolean;
  totalOccupants: number;
}

export interface ReservationRequest {
  clientId?: number;
  client?: ClientInfo;
  chambreId: number;
  apartmentId?: number;
  dateArrivee: string;
  dateDepart: string;
  salleId?: number;
  startDateTime?: string;
  endDateTime?: string;
  nombrePersonnes: number;
  occupantDetails: OccupantDetails;
  isCreatedCompte?: boolean;
}

export interface ReservationResponse {
  id: number;
  status: string;
  message?: string;
}

// Interfaces pour les réservations du client
export interface ClientResponseDTO {
  id: number;
  nom: string;
  prenom: string;
  email: string;
  telephone: string;
  adresse: string;
}

export interface ChambreDto {
  id: number;
  numero: number;
  type: string;
  prixParNuit: number;
  statut: string;
  etage: number;
  capacite: number;
}

export interface OccupantDetailsDto {
  nombreAdultes: number;
  nombreEnfants: number;
  avecAnimalCompagnie: boolean;
  ageEnfantSuperieurASept: boolean;
  totalOccupants: number;
}

export interface ReservationResponseDto {
  id: number;
  statut: string;
  montantTotal: number;
  montantPaye: number;
  montantRestant: number;
  nombrePersonnes: number;
  nombreNuitee: number;
  nombreNuiteePayee: number;
  nombreNuiteeRestant: number;
  client: ClientResponseDTO;
  chambre: ChambreDto;
  salleDTO: any;
  apartment: any;
  dateArrivee: string;
  dateDepart: string;
  startDateTime: string;
  endDateTime: string;
  occupantDetails: OccupantDetailsDto;
  apporteurAffaireDto: any;
}

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  private readonly apiUrl = environment.apiUrl;
  private http = inject(HttpClient);

  createReservation(reservation: ReservationRequest): Observable<ReservationResponse> {
    return this.http.post<ReservationResponse>(
      `${this.apiUrl}/frontOfficeController/reservationsForFrontOffice`,
      reservation
    );
  }

  getMyReservations(email: string): Observable<ReservationResponseDto[]> {
    return this.http.get<ReservationResponseDto[]>(
      `${this.apiUrl}/frontOfficeController/myReservations`,
      { params: { email } }
    );
  }
}
